(ns manage.adset-decision-tree-page.editor.root-node
  (:require ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItemButton$default" :as ListItemButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/wpp/arrows/trend-ascent.svg$default" :as TrendAscent]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            ["src/svg/wpp/content-actions/redo.svg$default" :as Redo]
            ["src/svg/wpp/content/iframe.svg$default" :as IFrame]
            ["src/svg/wpp/content/key.svg$default" :as Key]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset.q]
            [manage.ad-variant.optimization-ocp.view :as optimization-ocp]
            [manage.adset-decision-tree-page.editor.node :refer [source-handle]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.tagging-and-trackers.ocp
             :as tagging-and-trackers-ocp]
            [manage.adset-decision-tree-page.view.common
             :refer [decision-tree-node-container
                     node-header
                     upgrade-ad-variants-button
                     warning-icon]]
            [manage.adset-decision-tree-page.view.context :as context]
            [manage.adset-decision-tree-page.view.hook :as hook]
            [manage.adset-integration-meta-settings.db
             :refer [use-settings-details]]
            [manage.adset.hooks :as ah]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui config-list-item
  [{:keys [start-icon action label content tooltip-title warning additional-content]}]
  ($ ListItemButton {:sx #js {"&:hover .config-item-action" #js {:display "block"}
                              :py 1
                              :px 0
                              :borderRadius 1}
                     :onClick (fn [e]
                                (.stopPropagation e)
                                (action))}
     ($ Stack {:direction "row"
               :gap 1
               :sx #js {:width "100%"
                        :alignItems "center"
                        :mr 1}}
        ($ Stack {:sx #js {:borderRadius 4
                           :p 1
                           :bgcolor "grey.80"}}
           ($ SvgIcon {:sx #js {:color "grey.30"
                                :fontSize "sm"}
                       :inheritViewBox true
                       :component start-icon}))
        ($ Stack {:direction "column"
                  :sx #js {:flexGrow 1
                           :minWidth 0}}
           ($ Typography label)
           ($ Tooltip {:placement "top"
                       :title tooltip-title}
              ($ Typography {:color "text.secondary"
                             :sx #js {:textOverflow "ellipsis"
                                      :overflow "hidden"
                                      :whiteSpace "nowrap"}}
                 content)))
        additional-content
        (when warning ($ warning-icon))
        ($ SvgIcon {:className "config-item-action"
                    :sx #js {:display "none"
                             :color "grey.30"}
                    :component Edit}))))

(defui optimization-config []
  (let [url-context (use-subscribe [:url-context])
        rotation-control-enabled? (use-flag :ad-variant-rotation-control)
        even-rotation? (use-subscribe [::sub/root-even-rotation-enabled?])
        weighted-node (use-subscribe [::sub/root-weighted-rotation-node])
        weighted-distribution? (use-subscribe [::sub/root-weighted-distribution-enabled?])
        weighted-rotation? (or weighted-node weighted-distribution?)
        {{:keys [test-state]} :data} (use-query
                                      (adset.q/adset-aco-active-configuration url-context))]
    ($ config-list-item
       {:start-icon TrendAscent
        :label (if rotation-control-enabled? "Ad Variant Rotation" "Optimize Delivery")
        :content (cond
                   (= test-state "started") "ACO enabled"
                   even-rotation? "Even rotation enabled"
                   weighted-rotation? "Weighted rotation enabled"
                   :else "Enable for optimized results")
        :action #(cond
                   weighted-node
                   (rf/dispatch [::event/set-selection
                                 [{:type :selection/decision-node
                                   :decision-node-id (:id weighted-node)}]])

                   (or even-rotation? weighted-distribution?
                       (not= test-state "started"))
                   (optimization-ocp/open-delivery-optimization rotation-control-enabled?)

                   (= test-state "started")
                   (rf/dispatch [:ocp/open {:id ::optimization-ocp/toggle-optimization}]))})))

(defui platform-config []
  (let [{:keys [summary problems]} (use-settings-details)
        {{published-decision-tree-id :id} :published} (uix/use-context context/decision-trees-context)]
    ($ config-list-item
       {:start-icon Key
        :label "Platform configuration"
        :warning (seq problems)
        :content (or (when-not (str/blank? summary) summary) "Not configured")
        :action #(rf/dispatch [:ocp/open {:id :adset-integration-settings/ocp-edit
                                          :props {:account-disabled (some? published-decision-tree-id)}}])})))

(defui tagging-and-trackers-config [selected-item]
  (let [initial-values (tagging-and-trackers-ocp/use-initial-values selected-item)
        summary (tagging-and-trackers-ocp/get-summary initial-values)]
    ($ config-list-item
       {:start-icon IFrame
        :label "Tagging and trackers"
        :content (or summary "Not configured")
        :tooltip-title summary
        :action #(rf/dispatch [:ocp/open {:id ::tagging-and-trackers-ocp/ocp
                                          :props {:initial-values initial-values
                                                  :selected-item selected-item}}])})))

(defui default-ad-variant-config [selected-item]
  (let [{:keys [edit-variants ad-variants any-variants-assigned on-upgrade]}
        (hook/use-ad-variant-controls {:selected-item selected-item
                                       :single-default-per-dimensions true})]
    ($ config-list-item
       {:start-icon Redo
        :label "Default Ad variant"
        :warning (not any-variants-assigned)
        :content (if any-variants-assigned
                   (str (-> ad-variants first :content-id) " (" (count ad-variants) ")")
                   "Not configured")
        :action edit-variants
        :additional-content (when on-upgrade
                              ($ upgrade-ad-variants-button {:on-upgrade on-upgrade}))})))

(defn decision-tree-root-node [^js props]
  (let [{:keys [selected id]} (->clj props)
        root-id (parse-long id)
        {:keys [description] :as node-data} (use-subscribe [::sub/node-data root-id])

        read-only (use-subscribe [::sub/editor-read-only])
        selected-item (use-subscribe [::sub/root-as-selected-item])
        social-adset? (ah/use-is-social-adset?)
        channel-has-defaults (hook/use-channel-has-defaults)
        aco-enabled? (use-flag :ad-variant-content-optimizing)
        rotation-control-enabled? (use-flag :ad-variant-rotation-control)]
    ($ decision-tree-node-container {:selected selected}
       ($ Stack {:direction "column"
                 :spacing 1}
          ($ node-header {:node-data node-data})
          (when-not read-only
            ($ :<>
               ($ Typography {:sx #js {:color "text.secondary"}}
                  description)
               ($ Divider)
               ($ List {:sx #js {:p 0}}
                  (when social-adset?
                    ($ platform-config))
                  (when channel-has-defaults
                    ($ default-ad-variant-config selected-item))
                  (when (or aco-enabled? rotation-control-enabled?)
                    ($ optimization-config))
                  ($ tagging-and-trackers-config selected-item)))))

       ($ source-handle {:id root-id
                         :is-root true}))))
